import { savedDisplayOperationState } from '../../hooks/useDisplayOperation';
import { DefaultValue } from 'recoil';
import { disabledContentsWithID } from '../DisabledContentsState';
import { applyContentsSettings } from '../../utils/ContentsSetting';

const debug = false;

/**
 * コンテンツの初期表示設定を行うRecoil Effect
 * 保存された表示設定を読み込み、無効化状態をチェックしながらコンテンツを復元する
 *
 * @param {string} contentsID - コンテンツの識別子
 * @returns {Function} Recoil effect関数
 */
const contentsPresetEffect =
  (contentsID) =>
    async ({ trigger, setSelf, getLoadable }) => {
      // 'get'トリガー時のみ実行（初期読み込み時）
      if (trigger !== 'get') return;

      // 保存された表示設定とコンテンツオブジェクトを取得
      const savedState = getLoadable(savedDisplayOperationState).contents;

      // 無効化状態をチェックし、完全に無効化されている場合は非表示に設定
      const disabledState = getLoadable(disabledContentsWithID(contentsID)).contents;
      if (
        disabledState === true ||
        (disabledState instanceof Object &&
          Object.values(disabledState).filter((v) => v).length === Object.keys(disabledState).length)
      ) {
        debug && console.log(`${contentsID} ---> disabled`);
        setSelf(false);
        return;
      }

      // 保存された設定が存在する場合、設定を復元
      if (savedState[contentsID]) {
        // 表示状態を取得してRecoil stateに設定
        setSelf(applyContentsSettings(contentsID, savedState[contentsID], disabledState));
      } else {
        // 保存された設定がない場合はデフォルト値を設定
        setSelf(new DefaultValue());
      }
    };

export default contentsPresetEffect;
